"use client";

import { useFilterContext } from "../../../providers";
import type {
  ColorFacetValue,
  CustomColorFacet,
  FacetValue,
} from "../../../types/filters.type";
import { FilterOptionList } from "../FilterOptionList";

interface Props {
  facet: CustomColorFacet;
  isCompact?: boolean;
}

export function CustomColorFilter({ facet, isCompact }: Props) {
  const { getSelectedValues, onSelectionChange } = useFilterContext();
  const selected = getSelectedValues(facet.field);

  const renderPrefix = (option: FacetValue) => {
    const { hex } = option as ColorFacetValue;
    return (
      <span
        className="size-5 shrink-0 rounded-full ml-2"
        style={{ backgroundColor: hex }}
        aria-hidden="true"
        data-testid={`color-dot-${option.value}`}
      />
    );
  };

  return (
    <FilterOptionList
      options={facet.values}
      selectedValues={selected}
      selector="Multiple"
      isCompact={isCompact}
      renderPrefix={renderPrefix}
      onSelectionChange={(values) => onSelectionChange(facet.field, values)}
    />
  );
}
